export type ChatMobileNavigationTelemetryEvent =
  | { name: 'chat_mobile_conversation_list_opened' }
  | { name: 'chat_mobile_conversation_selected' }
  | { name: 'chat_mobile_conversation_list_closed' }
  | {
      name: 'chat_mobile_presentation_failed';
      stage: 'render';
    };

export type ChatMobileNavigationTelemetrySink = (
  event: ChatMobileNavigationTelemetryEvent
) => void;

let telemetrySink: ChatMobileNavigationTelemetrySink | undefined;

export const emitChatMobileNavigationTelemetry = (
  event: ChatMobileNavigationTelemetryEvent
): void => {
  try {
    telemetrySink?.(event);
  } catch {
    // Telemetry must never prevent mobile Chat navigation or recovery.
  }
};

export const setChatMobileNavigationTelemetrySink = (
  sink?: ChatMobileNavigationTelemetrySink
): (() => void) => {
  telemetrySink = sink;
  return () => {
    if (telemetrySink === sink) telemetrySink = undefined;
  };
};
